/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Soft_SkillsInputs */

const en_soft_skills = /** @type {(inputs: Soft_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soft skills`)
};

const de_soft_skills = /** @type {(inputs: Soft_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soft Skills`)
};

/**
* | output |
* | --- |
* | "Soft skills" |
*
* @param {Soft_SkillsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const soft_skills = /** @type {((inputs?: Soft_SkillsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Soft_SkillsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_soft_skills(inputs)
	return en_soft_skills(inputs)
});